import {ModuleController} from "../../../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../../../infrastructure/domain-services/base-managed-service";
import {SideBarModuleConfig} from "./side-bar-module.config";
import {SideBarModuleStore} from "./side-bar-module.store";
import {SideBarModuleHandlers} from "./handlers/side-bar-module.handlers";

export class SideBarModuleController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, SideBarModuleConfig, SideBarModuleStore, SideBarModuleHandlers];
}

